/* Compartiendo Mates — interacciones (prefijo cmt-) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cmt-reveal:not(.cmt-visible), .cmt-hero:not(.cmt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cmt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cmt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* Cifras que cuentan al aparecer */
  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-cmt-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-cmt-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      if (reduce) { el.textContent = target.toLocaleString('es-AR', { minimumFractionDigits: dec }); return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var v = target * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toLocaleString('es-AR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave del hero */
  function initParallax() {
    var heros = document.querySelectorAll('[data-cmt-parallax]');
    if (!heros.length || reduce) return;
    var ticking = false;
    function update() {
      heros.forEach(function (h) {
        var media = h.querySelector('.cmt-hero__media');
        if (!media) return;
        var k = parseFloat(h.getAttribute('data-cmt-parallax')) || 0;
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        media.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Página de producto ---------- */
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var m = fmt.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var tipo = m ? m[1] : 'amount';
    var n = cents / 100;
    var dec = (tipo.indexOf('no_decimals') > -1 || cents % 100 === 0) ? 0 : 2;
    var locale = tipo.indexOf('comma_separator') > -1 ? 'es-AR' : 'en-US';
    var s = n.toLocaleString(locale, { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-cmt-pdp]').forEach(function (pdp) {
      if (pdp.dataset.cmtReady) return;
      pdp.dataset.cmtReady = '1';
      var dataEl = pdp.querySelector('[data-cmt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var descTransf = parseFloat(pdp.getAttribute('data-descuento')) || 0;
      var cuotas = parseInt(pdp.getAttribute('data-cuotas'), 10) || 0;
      var fmt = pdp.getAttribute('data-money-format');
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var btn = pdp.querySelector('[data-cmt-add]');
      var btnLabel = btn ? btn.getAttribute('data-label') : '';
      var btnSold = btn ? btn.getAttribute('data-sold') : '';

      /* Galería */
      var slides = pdp.querySelectorAll('.cmt-gal__slide');
      var thumbs = pdp.querySelectorAll('.cmt-gal__thumb');
      var current = 0;
      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
        var t = thumbs[current];
        if (t && t.scrollIntoView && window.innerWidth < 990) t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = pdp.querySelector('.cmt-gal__nav--prev');
      var next = pdp.querySelector('.cmt-gal__nav--next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var main = pdp.querySelector('.cmt-gal__main');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      /* Variantes */
      var fieldsets = pdp.querySelectorAll('[data-cmt-option]');
      function selected() {
        var vals = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var out = fs.querySelector('[data-cmt-option-value]');
          if (out && c) out.textContent = c.value;
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < vals.length; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function setText(sel, txt) { pdp.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
      function update() {
        if (!fieldsets.length) return;
        var v = findVariant(selected());
        if (!v) {
          if (btn) { btn.disabled = true; btn.textContent = btnSold; }
          return;
        }
        if (idInput) idInput.value = v.id;
        setText('[data-cmt-price]', money(v.price, fmt));
        setText('[data-cmt-transf]', money(Math.round(v.price * (100 - descTransf) / 100), fmt));
        if (cuotas) setText('[data-cmt-cuota]', money(Math.round(v.price / cuotas), fmt));
        pdp.querySelectorAll('[data-cmt-compare]').forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price, fmt); el.hidden = false; }
          else { el.hidden = true; }
        });
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btnLabel : btnSold; }
        pdp.querySelectorAll('[data-cmt-stock]').forEach(function (el) {
          el.classList.toggle('is-agotado', !v.available);
          el.textContent = v.available ? el.getAttribute('data-in') : el.getAttribute('data-out');
        });
        if (v.featured_media_position && slides.length) show(v.featured_media_position - 1);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

      /* Cantidad */
      var qty = pdp.querySelector('.cmt-qty input');
      pdp.querySelectorAll('[data-cmt-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-cmt-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      /* Barra fija en móvil */
      var sticky = pdp.querySelector('.cmt-sticky');
      if (sticky && btn && 'IntersectionObserver' in window) {
        var btnVisible = false;
        var precio = pdp.querySelector('.cmt-precio');
        function revisar() {
          var pasado = precio ? precio.getBoundingClientRect().bottom < 0 : window.scrollY > 500;
          var fin = document.querySelector('.cmt-footer');
          var enPie = fin ? fin.getBoundingClientRect().top < window.innerHeight : false;
          sticky.classList.toggle('is-visible', pasado && !btnVisible && !enPie);
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { btnVisible = e.isIntersecting; revisar(); });
        });
        io.observe(btn);
        window.addEventListener('scroll', function () { requestAnimationFrame(revisar); }, { passive: true });
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (form) { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); } });
      }
    });
  }

  /* Entrega estimada (días hábiles) */
  function sumarHabiles(fecha, dias) {
    var d = new Date(fecha);
    while (dias > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) dias--;
    }
    return d;
  }
  function fmtFecha(d) {
    return d.toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
  }
  function initEntrega(root) {
    (root || document).querySelectorAll('[data-cmt-entrega]').forEach(function (el) {
      var hoy = new Date();
      var desp = parseInt(el.getAttribute('data-despacho'), 10) || 0;
      var min = parseInt(el.getAttribute('data-min'), 10) || 1;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      var fDesp = sumarHabiles(hoy, desp);
      var fMin = sumarHabiles(fDesp, min);
      var fMax = sumarHabiles(fDesp, max);
      var a = el.querySelector('[data-cmt-fecha="despacho"]');
      var b = el.querySelector('[data-cmt-fecha="entrega"]');
      if (a) a.textContent = desp === 0 ? 'Hoy' : fmtFecha(fDesp);
      if (b) b.textContent = fmtFecha(fMin) + ' – ' + fMax.getDate() + ' ' + fMax.toLocaleDateString('es-AR', { month: 'short' }).replace(/\./g, '');
    });
  }

  /* Carrusel deslizable (opiniones): dedo en celular, flechas en compu, avance automático suave */
  function initCarrusel(root) {
    (root || document).querySelectorAll('[data-cmt-carrusel]').forEach(function (c) {
      if (c.dataset.cmtReady) return;
      c.dataset.cmtReady = '1';
      var track = c.querySelector('[data-cmt-track]');
      if (!track) return;
      var prev = c.querySelector('[data-cmt-prev]');
      var next = c.querySelector('[data-cmt-next]');
      var prog = c.querySelector('[data-cmt-progreso]');
      var seg = parseInt(c.getAttribute('data-auto'), 10) || 0;
      var timer = null, pausaHasta = 0, visible = false;

      function paso() {
        var card = track.querySelector('.cmt-res__card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function alFinal() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; }
      function mover(dir) {
        if (dir > 0 && alFinal()) track.scrollTo({ left: 0 });
        else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: dir * paso() });
      }
      function actualizar() {
        if (!prog) return;
        var max = track.scrollWidth - track.clientWidth;
        var ancho = Math.max(12, Math.min(100, track.clientWidth / track.scrollWidth * 100));
        prog.style.width = ancho + '%';
        var p = max > 0 ? track.scrollLeft / max : 0;
        prog.style.transform = 'translateX(' + (p * (100 / ancho * 100 - 100)) + '%)';
      }
      function interaccion() { pausaHasta = Date.now() + 8000; }

      if (prev) prev.addEventListener('click', function () { interaccion(); mover(-1); });
      if (next) next.addEventListener('click', function () { interaccion(); mover(1); });
      ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
        track.addEventListener(ev, interaccion, { passive: true });
      });
      track.addEventListener('scroll', function () { requestAnimationFrame(actualizar); }, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();

      if (seg && !reduce) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(c);
        } else { visible = true; }
        timer = setInterval(function () {
          if (!visible || document.hidden || Date.now() < pausaHasta) return;
          if (c.matches(':hover') && window.matchMedia('(hover: hover)').matches) return;
          mover(1);
        }, seg * 1000);
      }
    });
  }

  /* Cuenta regresiva de campañas */
  function initCuenta(root) {
    (root || document).querySelectorAll('[data-cmt-cuenta]').forEach(function (el) {
      if (el.dataset.cmtReady) return;
      el.dataset.cmtReady = '1';
      var fin = new Date(el.getAttribute('data-cmt-cuenta')).getTime();
      if (isNaN(fin)) return;
      var d = el.querySelector('[data-u="d"]'), h = el.querySelector('[data-u="h"]'), m = el.querySelector('[data-u="m"]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      var vencido = el.getAttribute('data-vencido');
      function tick() {
        var resto = Math.max(0, fin - Date.now());
        if (resto === 0) {
          var txt = el.querySelector('[data-cmt-urg-texto]'), rel = el.querySelector('[data-cmt-urg-reloj]');
          if (vencido) { if (txt) txt.textContent = vencido; if (rel) rel.hidden = true; }
          else if (el.classList.contains('cmt-urg')) { el.hidden = true; }
          return;
        }
        var dias = Math.floor(resto / 86400000);
        var horas = Math.floor(resto / 3600000) % 24;
        var mins = Math.floor(resto / 60000) % 60;
        if (d) d.textContent = dias;
        var dl = el.querySelector("[data-u=\"dl\"]");
        if (dl) dl.textContent = dias === 1 ? "día" : "días";
        if (h) h.textContent = pad(horas);
        if (m) m.textContent = pad(mins);
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  /* Ordenar colección: recarga al elegir */
  function initOrden(root) {
    (root || document).querySelectorAll('[data-cmt-orden]').forEach(function (form) {
      if (form.dataset.cmtReady) return;
      form.dataset.cmtReady = '1';
      var sel = form.querySelector('select');
      if (!sel) return;
      var inicial = sel.value;
      function ir() {
        if (sel.value === inicial) return;
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      }
      sel.addEventListener('change', ir);
      sel.addEventListener('input', ir);
    });
  }

  /* Filtros rápidos de colección */
  function initFiltros(root) {
    (root || document).querySelectorAll('[data-cmt-filtros]').forEach(function (box) {
      if (box.dataset.cmtReady) return;
      box.dataset.cmtReady = '1';
      var grid = box.parentNode.querySelector('.cmt-prod__grid');
      if (!grid) return;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.cmt-filtro');
        if (!b) return;
        var f = b.getAttribute('data-f');
        box.querySelectorAll('.cmt-filtro').forEach(function (x) { x.classList.toggle('is-activo', x === b); });
        grid.querySelectorAll('[data-marcas]').forEach(function (it) {
          it.hidden = f !== '' && it.getAttribute('data-marcas').indexOf(',' + f + ',') === -1;
        });
      });
    });
  }

  /* Combinalo con: agrega el producto + los extras marcados */
  function initCombina(root) {
    (root || document).querySelectorAll('[data-cmt-combina]').forEach(function (box) {
      if (box.dataset.cmtReady) return;
      box.dataset.cmtReady = '1';
      var form = box.closest('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        var extras = Array.prototype.slice.call(box.querySelectorAll('input:checked'));
        if (!extras.length || !window.fetch) return;
        e.preventDefault();
        var fd = new FormData(form);
        var props = {};
        fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
        var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: props }];
        extras.forEach(function (x) { items.push({ id: Number(x.value), quantity: 1 }); });
        var btn = form.querySelector('[data-cmt-add]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = '/cart'; })
          .catch(function () { if (btn) btn.disabled = false; HTMLFormElement.prototype.submit.call(form); });
      });
    });
  }

  /* Visor de imágenes (diseños de grabado) */
  function initVisor(root) {
    (root || document).querySelectorAll('[data-cmt-lightbox]').forEach(function (g) {
      if (g.dataset.cmtReady) return;
      g.dataset.cmtReady = '1';
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-full]');
        if (!b) return;
        var v = document.querySelector('.cmt-visor');
        if (!v) {
          v = document.createElement('div');
          v.className = 'cmt-visor';
          v.setAttribute('role', 'dialog');
          v.setAttribute('aria-modal', 'true');
          v.innerHTML = '<img alt=""><button type="button" aria-label="Cerrar">×</button>';
          document.body.appendChild(v);
          v.addEventListener('click', function (ev) { if (ev.target === v || ev.target.tagName === 'BUTTON') v.hidden = true; });
          document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') v.hidden = true; });
        }
        v.querySelector('img').src = b.getAttribute('data-full');
        v.hidden = false;
        v.querySelector('button').focus();
      });
    });
  }

  /* Videos: que sigan reproduciéndose (algunos celulares los pausan) */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('.cmt-section video[autoplay], .cmt-hero video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      if (v.dataset.cmtReady) return;
      v.dataset.cmtReady = '1';
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('controls');
      var visible = false;
      function play() { if (visible && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          if (visible) play(); else v.pause();
        }, { threshold: 0.2 }).observe(v);
      } else { visible = true; play(); }
      v.addEventListener('pause', function () { setTimeout(play, 400); });
      v.addEventListener('ended', function () { v.currentTime = 0; play(); });
    });
    ['touchstart', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, function () { vids.forEach(function (v) { if (v.paused) { var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < window.innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } }); }, { passive: true, once: ev === 'touchstart' });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) vids.forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < window.innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }); });
  }

  /* Avisos con opiniones reales */
  function initAvisos() {
    var box = document.querySelector('[data-cmt-avisos]');
    if (!box || box.dataset.cmtReady) return;
    box.dataset.cmtReady = '1';
    try { if (sessionStorage.getItem('cmtAvisosOff') === '1') return; } catch (e) {}
    var datos = [];
    var tpl = box.querySelector('[data-cmt-avisos-datos]');
    var src = tpl && tpl.content ? tpl.content : tpl;
    if (src) src.querySelectorAll('[data-nombre]').forEach(function (d) { datos.push({ n: d.getAttribute('data-nombre'), t: d.getAttribute('data-texto'), f: d.getAttribute('data-foto') }); });
    if (!datos.length) return;
    for (var i = datos.length - 1; i > 0; i--) { var k = Math.floor(Math.random() * (i + 1)); var tmp = datos[i]; datos[i] = datos[k]; datos[k] = tmp; }
    var inicio = (parseInt(box.getAttribute('data-inicio'), 10) || 8) * 1000;
    var dura = (parseInt(box.getAttribute('data-dura'), 10) || 6) * 1000;
    var pausa = (parseInt(box.getAttribute('data-pausa'), 10) || 20) * 1000;
    var max = parseInt(box.getAttribute('data-max'), 10) || 4;
    var foto = box.querySelector('.cmt-aviso__fotos'), texto = box.querySelector('.cmt-aviso__texto'), autor = box.querySelector('.cmt-aviso__autor span');
    var n = 0, timer = null, apagado = false;
    box.hidden = false;
    function mostrar() {
      if (apagado || n >= max || document.hidden) { if (!apagado && n < max) timer = setTimeout(mostrar, pausa); return; }
      var d = datos[n % datos.length];
      foto.innerHTML = d.f ? '<img src="' + d.f + '" alt="" loading="lazy">' : (d.n || '?').charAt(0);
      texto.textContent = '“' + d.t + '”';
      autor.textContent = d.n;
      box.classList.add('is-visible');
      n++;
      timer = setTimeout(function () {
        box.classList.remove('is-visible');
        if (n < max) timer = setTimeout(mostrar, pausa);
      }, dura);
    }
    box.querySelector('.cmt-aviso__cerrar').addEventListener('click', function () {
      apagado = true; clearTimeout(timer); box.classList.remove('is-visible');
      try { sessionStorage.setItem('cmtAvisosOff', '1'); } catch (e) {}
    });
    timer = setTimeout(mostrar, inicio);
  }

  /* Elegir diseño: ventana con las imágenes y botones numerados */
  function initElegirDisenos(root) {
    (root || document).querySelectorAll('[data-cmt-ver-disenos]').forEach(function (link) {
      if (link.dataset.cmtReady) return;
      link.dataset.cmtReady = '1';
      var box = link.closest('.cmt-elegir');
      var sel = box ? box.querySelector('select') : null;
      link.addEventListener('click', function (e) {
        var imgs = document.querySelectorAll('#cmt-disenos [data-full]');
        e.preventDefault();
        if (!imgs.length || !sel) { var gal = document.getElementById('cmt-disenos'); if (gal) gal.scrollIntoView({ behavior: 'smooth' }); return; }
        var modal = document.querySelector('.cmt-dmodal');
        if (!modal) {
          modal = document.createElement('div');
          modal.className = 'cmt-dmodal';
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          modal.setAttribute('aria-label', 'Elegí tu diseño');
          var html = '<div class="cmt-dmodal__head"><p>Elegí tu diseño</p><button type="button" class="cmt-dmodal__cerrar" aria-label="Cerrar">×</button></div><div class="cmt-dmodal__body">';
          imgs.forEach(function (b) {
            var cap = b.querySelector('.cmt-dis__cap');
            html += '<figure><img src="' + b.getAttribute('data-full') + '" alt="" loading="eager">' + (cap ? '<figcaption>' + cap.textContent + '</figcaption>' : '') + '</figure>';
          });
          html += '</div><div class="cmt-dmodal__pie"><p>Tocá el número del diseño que elegiste:</p><div class="cmt-dmodal__nums"></div></div>';
          modal.innerHTML = html;
          document.body.appendChild(modal);
          modal.querySelector('.cmt-dmodal__cerrar').addEventListener('click', function () { cerrar(); });
          document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') cerrar(); });
        }
        var nums = modal.querySelector('.cmt-dmodal__nums');
        nums.innerHTML = '';
        var opciones = Array.prototype.slice.call(sel.options);
        opciones.sort(function (x, y) { var a = /\d+$/.test(x.value) ? 0 : 1, c = /\d+$/.test(y.value) ? 0 : 1; return a - c; });
        opciones.forEach(function (o) {
          var m = o.value.match(/(\d+)$/);
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = m ? m[1] : o.textContent;
          if (!m) b.className = 'es-texto';
          if (o.value === sel.value) b.classList.add('is-activo');
          b.addEventListener('click', function () {
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            cerrar();
            box.classList.remove('cmt-elegir--ok');
            void box.offsetWidth;
            box.classList.add('cmt-elegir--ok');
            box.scrollIntoView({ block: 'center', behavior: 'smooth' });
          });
          nums.appendChild(b);
        });
        modal.hidden = false;
        document.documentElement.classList.add('cmt-sin-scroll');
        modal.querySelector('.cmt-dmodal__body').scrollTop = 0;
        function cerrar() { modal.hidden = true; document.documentElement.classList.remove('cmt-sin-scroll'); }
        modal._cerrar = cerrar;
      });
    });
  }

  /* Modo Cyber: cuenta regresiva y se oculta solo fuera de fecha */
  function initCyber(root) {
    (root || document).querySelectorAll('[data-cyber]').forEach(function (el) {
      if (el.dataset.cmtReady) return;
      el.dataset.cmtReady = '1';
      var ini = new Date(el.getAttribute('data-ini')).getTime(), fin = new Date(el.getAttribute('data-fin')).getTime();
      if (isNaN(fin)) return;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var ahora = Date.now();
        if ((!isNaN(ini) && ahora < ini) || ahora >= fin) { el.hidden = true; el.style.display = 'none'; return false; }
        var r = fin - ahora, d = Math.floor(r / 86400000), h = Math.floor(r / 3600000) % 24, m = Math.floor(r / 60000) % 60, s = Math.floor(r / 1000) % 60;
        el.querySelectorAll('[data-cy-reloj]').forEach(function (x) { x.textContent = (d > 0 ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(m) + ':' + pad(s); });
        var u = { d: d, h: pad(h), m: pad(m), s: pad(s) };
        el.querySelectorAll('[data-cy-u]').forEach(function (x) { var nv = '' + u[x.getAttribute('data-cy-u')]; if (x.textContent !== nv) { x.textContent = nv; x.classList.remove('is-flip'); void x.offsetWidth; x.classList.add('is-flip'); } });
        return true;
      }
      if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
    });
  }

  function initAll(root) {
    initCyber(root);
    initElegirDisenos(root);
    initAvisos();
    initFiltros(root);
    initCombina(root);
    initVisor(root);
    initVideos(root);
    initOrden(root);
    initCuenta(root);    initCarrusel(root);
    initReveal(root);
    initCifras(root);
    initProducto(root);
    initEntrega(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initParallax();
  });

  /* Editor de Shopify: reinicia al cargar/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
